import { ProcessedConnection } from '../types';
import { Edge } from 'reactflow';

/**
 * Remove conexões duplicadas baseadas no ID
 * Mantém apenas a primeira ocorrência de cada ID único
 */
export function getUniqueConnections(connections: ProcessedConnection[]): ProcessedConnection[] {
  const seen = new Set<string>();
  const unique: ProcessedConnection[] = [];
  
  for (const conn of connections) {
    if (conn && conn.id && !seen.has(conn.id)) {
      seen.add(conn.id);
      unique.push(conn);
    }
  }
  
  return unique;
}

/**
 * Remove arestas duplicadas do React Flow baseadas no ID
 * Mantém apenas a primeira ocorrência de cada ID único
 */
export function getUniqueEdges(edges: Edge[]): Edge[] {
  const seen = new Set<string>();
  const unique: Edge[] = [];
  
  for (const edge of edges) {
    if (edge && edge.id && !seen.has(edge.id)) {
      seen.add(edge.id);
      unique.push(edge);
    }
  }
  
  return unique;
}

/**
 * Diagnóstico: Verifica se há duplicatas em uma lista de conexões
 * Retorna array com IDs duplicados e suas contagens
 */
export function findDuplicateConnections(connections: ProcessedConnection[]): { id: string, count: number }[] {
  const counts = new Map<string, number>();
  
  connections.forEach(conn => {
    if (conn && conn.id) {
      counts.set(conn.id, (counts.get(conn.id) || 0) + 1);
    }
  });
  
  const duplicates: { id: string, count: number }[] = [];
  counts.forEach((count, id) => {
    if (count > 1) {
      duplicates.push({ id, count });
    }
  });
  
  return duplicates;
}
